export default __webpack_public_path__ + "static/media/close-icon.6a1d9621.svg";